import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, Grid, IconButton, Typography } from '@material-ui/core';
import { useMutation } from '@apollo/react-hooks';
import Send from '@jda/lui-common-icon-library/ui/Send';
import ScrollToBottom from 'react-scroll-to-bottom';
import X from '@jda/lui-common-icon-library/ui/X';
import useStyles from './style';
import moment from 'moment';
import { ADD_CUSTOMER_PROVIDER_RELATION } from '../graphQL/queries';
import { formatString } from '../../utils/helpers';

interface ChatProps {
  participantType: any;
  handleDialogClose: () => void;
  dialogOpen: true | false;
  formData: any;
  workflowCode: any;
}
const Chat = (props: ChatProps) => {
  const { participantType, formData } = props;
  const classes = useStyles();
  const [currentMessage, setCurrentMessage] = useState('');
  const [messageList, setMessageList] = useState<any>([]);
  const [addCustomerProvider] = useMutation(ADD_CUSTOMER_PROVIDER_RELATION);

  useEffect(() => {
    if (formData?.connectionNote) {
      setMessageList(formatString(formData?.connectionNote));
    }
  }, [formData?.connectionNote]);

  const sendMessage = () => {
    if (currentMessage) {
      const list = messageList;
      list.push({
        date: new Date(),
        message: currentMessage,
        from: participantType
      });
      setMessageList(list);
      handleSubmit(list);
      setCurrentMessage('');
    }
  };

  const handleSubmit = (message: any) => {
    addCustomerProvider({
      variables: {
        workflowCode: props.workflowCode,
        providerCode: props.formData.participantType !== 'AGGREGATOR' ? formData?.providerCode : 'DEFAULT',
        customerCode: formData?.customerCode,
        aggregatorCode: props.formData.participantType === 'AGGREGATOR' ? props.formData.partnerCode : 'DEFAULT',
        providerCustomerCode: formData.providerCustomerCode,
        additionalCreds: formData?.additionalCreds,
        status: formData?.status,
        operationUrls: formData?.operationUrls || {},
        connectionConfig: formData.connectionConfig,
        connectionNote: JSON.stringify(message),
        method: 'PUT'
      }
    });
  };
  return (
    <Dialog onClose={props.handleDialogClose} open={props.dialogOpen} fullWidth maxWidth="md">
      <Grid container alignItems="center" style={{ padding: '10px' }}>
        <Grid item xs={7}>
          <Typography variant="h3">Lets Chat</Typography>
        </Grid>
        <Grid item xs={5}>
          <IconButton onClick={props.handleDialogClose} className={classes.iconButton}>
            <X />
          </IconButton>
        </Grid>
      </Grid>
      <DialogContent dividers>
        <Grid container>
          <Grid className={classes.chatBody} item xs={12}>
            <ScrollToBottom className="message-container">
              {messageList?.length > 0 &&
                messageList?.map((item: any) => (
                  <Grid
                    className={classes.message}
                    style={participantType === item?.from ? { textAlign: 'right', background: 'rgb(217 217 217)' } : {}}
                  >
                    <Grid className={classes.messageContent}>{item?.message}</Grid>
                    <Grid className={classes.messageMeta}>{moment(item?.date).format('DD-MM-YYYY H:SS')}</Grid>
                  </Grid>
                ))}
            </ScrollToBottom>
          </Grid>
          <Grid item xs={12}>
            <input
              className={classes.chatFooter}
              type="text"
              value={currentMessage}
              placeholder="Hey..."
              onChange={event => {
                setCurrentMessage(event.target.value);
              }}
              onKeyPress={event => {
                event.key === 'Enter' && sendMessage();
              }}
            />
            <button className={classes.sendBtn} onClick={sendMessage}>
              <Send />
            </button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Chat;
